var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandscapeDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 727,
    height: 276,
    viewBox: "0 0 727 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446.754 76.6501C458.199 76.6501 467.477 67.3721 467.477 55.9271C467.477 44.4821 458.199 35.2041 446.754 35.2041C435.309 35.2041 426.031 44.4821 426.031 55.9271C426.031 67.3721 435.309 76.6501 446.754 76.6501Z",
    fill: "#F3C12E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.837 126.242H598.958L615.261 332.819H25.9741L96.0253 265.25L110.537 258.53L100.324 240.128L182.837 126.242Z",
    fill: "url(#paint0_linear_1533_2467)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M633.434 110.949L589.07 63.0265L544.708 110.949",
    fill: "#D8D9EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M589.07 63.0265L595.527 110.949H633.506L589.07 63.0265Z",
    fill: "#407AAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508.529 110.949L472.781 72.3362L437.037 110.949",
    fill: "#D8D9EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M472.782 72.3362L477.985 110.949H510.518L472.782 72.3362Z",
    fill: "#407AAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M595.751 110.949L536.81 47.2805L477.871 110.949",
    fill: "#D8D9EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M536.81 47.2805L543.312 110.949L570.23 83.3794L536.81 47.2805Z",
    fill: "#407AAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.751 118.45H205.065C205.065 118.45 260.058 64.6137 324.751 118.45Z",
    fill: "#F3C12E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.831 116.807C288.804 99.8497 308.398 92.2124 327.91 95.4133C331.761 96.048 335.535 97.0796 339.174 98.4916C369.923 110.379 410.293 54.5052 439.487 71.1619C468.681 87.8186 506.614 129.459 506.614 129.459H259.168L271.831 116.807Z",
    fill: "#439E9B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M422.966 127.568H676.896C676.896 127.568 661.363 112.286 624.521 106.917C587.68 101.549 560.635 76.8872 520.134 79.0309C481.053 81.108 422.966 127.568 422.966 127.568Z",
    fill: "#407AAC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M362.054 135.781H570.85C570.85 135.781 538.849 120.091 514.214 113.814C489.579 107.538 455.512 128.593 429.57 124.112C426.326 123.553 423.144 123.18 420.061 122.953C403.596 121.747 387.061 124.626 372.74 131.014L362.054 135.781Z",
    fill: "#F3C12E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M331.984 139.504H161.337C161.337 139.504 187.498 106.872 207.624 93.8181C227.751 80.7643 255.597 124.556 276.799 115.236C279.292 114.133 281.904 113.324 284.583 112.823C298.036 110.315 311.551 116.299 323.255 129.587L331.984 139.504Z",
    fill: "#D8D9EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.153 106.893H208.213V108.928H209.153V106.893Z",
    fill: "#163240"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.682 95.2083L207.451 99.8444L206.224 104.478H207.031L206.224 107.519H208.682H208.761V95.5038L208.682 95.2083Z",
    fill: "#439E9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.335 104.478H211.142L209.912 99.8444L208.761 95.5038V107.519H211.142L210.335 104.478Z",
    fill: "#163240"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215.355 106.065H214.505V107.905H215.355V106.065Z",
    fill: "#163240"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.932 95.5038L213.818 99.6926L212.708 103.884H213.435L212.708 106.632H214.932H215.001V95.7701L214.932 95.5038Z",
    fill: "#439E9B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M216.425 103.884H217.152L216.042 99.6927L215 95.7701V106.632H217.152L216.425 103.884Z",
    fill: "#163240"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M220.676 112.272H219.826V114.112H220.676V112.272Z",
    fill: "#163240"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.249 101.708L219.139 105.9L218.026 110.089H218.756L218.026 112.837H220.249H220.321V101.975L220.249 101.708Z",
    fill: "#439E9B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M221.743 110.089H222.473L221.363 105.9L220.321 101.975V112.837H222.473L221.743 110.089Z",
    fill: "#163240"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.848 110.427H225.999V112.267H226.848V110.427Z",
    fill: "#163240"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M226.425 99.8657L225.312 104.055L224.201 108.246H224.931L224.201 110.994H226.425H226.494V100.132L226.425 99.8657Z",
    fill: "#439E9B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M227.919 108.246H228.648L227.535 104.054L226.494 100.132V110.994H228.648L227.919 108.246Z",
    fill: "#163240"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M288.738 126.847H287.888V128.687H288.738V126.847Z",
    fill: "#163240"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M288.311 116.283L287.201 120.472L286.088 124.663H286.818L286.088 127.411H288.311H288.383V116.549L288.311 116.283Z",
    fill: "#439E9B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M289.805 124.663H290.535L289.425 120.472L288.383 116.549V127.411H290.535L289.805 124.663Z",
    fill: "#163240"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M294.098 124.674H293.249V126.514H294.098V124.674Z",
    fill: "#163240"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.675 114.112L292.562 118.301L291.451 122.493H292.181L291.451 125.241H293.675H293.744V114.379L293.675 114.112Z",
    fill: "#439E9B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M295.169 122.493H295.898L294.785 118.301L293.744 114.379V125.241H295.898L295.169 122.493Z",
    fill: "#163240"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M311.964 132.127H311.114V133.967H311.964V132.127Z",
    fill: "#163240"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M311.538 121.563L310.427 125.755L309.317 129.944H310.044L309.317 132.692H311.538H311.61V121.83L311.538 121.563Z",
    fill: "#439E9B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M313.034 129.944H313.761L312.651 125.755L311.609 121.83V132.692H313.761L313.034 129.944Z",
    fill: "#163240"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M401.119 224.848H291.646C291.646 224.848 341.946 143.772 401.119 224.848Z",
    fill: "#407AAC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M323.534 211.121H321.404V215.736H323.534V211.121Z",
    fill: "#163240"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M322.469 184.627L319.681 195.138L316.893 205.646H318.723L316.893 212.54H322.469H322.645V185.296L322.469 184.627Z",
    fill: "#439E9B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M326.216 205.646H328.045L325.257 195.138L322.645 185.296V212.54H328.045L326.216 205.646Z",
    fill: "#163240"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M339.581 206.967H337.669V211.107H339.581V206.967Z",
    fill: "#163240"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M338.625 183.194L336.122 192.624L333.622 202.056H335.262L333.622 208.242H338.625H338.785V183.794L338.625 183.194Z",
    fill: "#439E9B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M341.989 202.056H343.629L341.126 192.624L338.785 183.794V208.242H343.629L341.989 202.056Z",
    fill: "#163240"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M355.585 197.486H353.673V201.627H355.585V197.486Z",
    fill: "#163240"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M354.627 173.714L352.126 183.144L349.623 192.576H351.266L349.623 198.762H354.627H354.786V174.314L354.627 173.714Z",
    fill: "#439E9B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M357.99 192.576H359.63L357.13 183.144L354.787 174.314V198.762H359.63L357.99 192.576Z",
    fill: "#163240"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M371.954 215.214H370.042V219.355H371.954V215.214Z",
    fill: "#163240"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M370.998 191.442L368.495 200.871L365.995 210.303H367.635L365.995 216.487H370.998H371.158V192.041L370.998 191.442Z",
    fill: "#439E9B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M374.362 210.303H376.002L373.499 200.871L371.158 192.041V216.487H376.002L374.362 210.303Z",
    fill: "#163240"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M410.037 123.734H409.214V125.518H410.037V123.734Z",
    fill: "#163240"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M409.627 113.492L408.549 117.556L407.47 121.617H408.179L407.47 124.282H409.627H409.696V113.75L409.627 113.492Z",
    fill: "#439E9B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M411.076 121.617H411.782L410.706 117.556L409.697 113.75V124.282H411.782L411.076 121.617Z",
    fill: "#163240"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M404.957 127.675H404.134V129.459H404.957V127.675Z",
    fill: "#163240"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M404.546 117.433L403.468 121.497L402.389 125.558H403.098L402.389 128.223H404.546H404.615V117.691L404.546 117.433Z",
    fill: "#439E9B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M405.995 125.558H406.701L405.625 121.497L404.616 117.691V128.223H406.701L405.995 125.558Z",
    fill: "#163240"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M399.694 123.246H398.872V125.031H399.694V123.246Z",
    fill: "#163240"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M399.284 113.005L398.206 117.068L397.127 121.129H397.836L397.127 123.795H399.284H399.354V113.263L399.284 113.005Z",
    fill: "#439E9B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M400.733 121.129H401.439L400.36 117.068L399.354 113.263V123.795H401.439L400.733 121.129Z",
    fill: "#163240"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M415.84 125.382H415.017V127.166H415.84V125.382Z",
    fill: "#163240"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M415.43 115.14L414.351 119.204L413.273 123.268H413.981L413.273 125.931H415.43H415.497V115.399L415.43 115.14Z",
    fill: "#439E9B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M416.879 123.268H417.584L416.506 119.204L415.497 115.399V125.931H417.584L416.879 123.268Z",
    fill: "#163240"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M204.503 181.349H103.689C103.689 181.349 145.676 47.1501 204.503 181.349Z",
    fill: "#99AAD1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M137.685 150.515H135.991V154.182H137.685V150.515Z",
    fill: "#163240"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M136.838 129.459L134.622 137.813L132.407 146.164H133.861L132.407 151.644H136.838H136.979V129.989L136.838 129.459Z",
    fill: "#439E9B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M139.818 146.164H141.269L139.053 137.813L136.979 129.989V151.644H141.269L139.818 146.164Z",
    fill: "#163240"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M147.386 148.619H145.889V151.862H147.386V148.619Z",
    fill: "#163240"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M146.638 129.989L144.678 137.381L142.718 144.771H144.004L142.718 149.617H146.638H146.763V130.46L146.638 129.989Z",
    fill: "#439E9B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M149.274 144.771H150.56L148.6 137.381L146.763 130.46V149.617H150.56L149.274 144.771Z",
    fill: "#163240"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M155.566 154.56H153.913V158.141H155.566V154.56Z",
    fill: "#163240"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M154.741 133.989L152.576 142.151L150.411 150.31H151.83L150.411 155.662H154.741H154.877V134.508L154.741 133.989Z",
    fill: "#439E9B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M157.649 150.31H159.071L156.906 142.151L154.877 134.508V155.662H159.071L157.649 150.31Z",
    fill: "#163240"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M226.641 224.619H50.7505C50.7505 224.619 72.4322 179.203 93.1818 164.687C113.931 150.171 147.913 207.997 169.768 197.633C172.318 196.413 175.008 195.511 177.778 194.949C191.647 192.161 205.574 198.815 217.637 213.589L226.641 224.619Z",
    fill: "#F3C12E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9639 198.874H84.0293V205.236H86.9639V198.874Z",
    fill: "#163240"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4963 162.352L81.6537 176.841L77.811 191.33H80.3302L77.811 200.831H85.4963H85.7413V163.276L85.4963 162.352Z",
    fill: "#439E9B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M90.665 191.33H93.1841L89.3415 176.841L85.7412 163.276V200.831H93.1841L90.665 191.33Z",
    fill: "#163240"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M106.691 197.953H104.193V203.364H106.691V197.953Z",
    fill: "#163240"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105.442 166.889L102.172 179.213L98.9019 191.535H101.048L98.9019 199.617H105.442H105.65V167.675L105.442 166.889Z",
    fill: "#439E9B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M109.836 191.535H111.979L108.709 179.213L105.649 167.675V199.617H111.979L109.836 191.535Z",
    fill: "#163240"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M196.935 208.319H194.667V213.238H196.935V208.319Z",
    fill: "#163240"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M195.801 180.084L192.829 191.285L189.857 202.488H191.807L189.857 209.835H195.801H195.99V180.798L195.801 180.084Z",
    fill: "#439E9B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M199.795 202.488H201.744L198.773 191.285L195.99 180.798V209.835H201.744L199.795 202.488Z",
    fill: "#163240"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M642.434 160.705L658.367 183.194L505.826 167.073L489.952 148.257C489.952 148.257 564.836 78.4392 642.434 160.705Z",
    fill: "#D8D9EB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M596.941 124.067H596.196V125.683H596.941V124.067Z",
    fill: "#163240"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M596.568 114.786L595.591 118.469L594.614 122.149H595.256L594.614 124.564H596.568H596.63V115.02L596.568 114.786Z",
    fill: "#439E9B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M597.881 122.149H598.523L597.546 118.469L596.63 115.021V124.564H598.523L597.881 122.149Z",
    fill: "#163240"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M415.208 174.921H534.282C534.282 174.921 504.96 153.053 492.452 144.297C479.945 135.541 462.654 164.895 449.483 158.647C447.946 157.913 446.325 157.37 444.655 157.031C436.296 155.351 427.903 159.361 420.633 168.269L415.208 174.921Z",
    fill: "#99AAD1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M440.973 163.609H439.375V167.07H440.973V163.609Z",
    fill: "#163240"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M440.173 143.738L438.083 151.62L435.993 159.505H437.364L435.993 164.674H440.173H440.307V144.238L440.173 143.738Z",
    fill: "#439E9B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M442.986 159.505H444.357L442.267 151.62L440.307 144.238V164.674H444.357L442.986 159.505Z",
    fill: "#163240"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M451.704 163.108H450.346V166.05H451.704V163.108Z",
    fill: "#163240"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M451.025 146.206L449.247 152.911L447.468 159.617H448.634L447.468 164.013H451.025H451.14V146.632L451.025 146.206Z",
    fill: "#439E9B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M453.416 159.617H454.583L452.804 152.912L451.14 146.632V164.013H454.583L453.416 159.617Z",
    fill: "#163240"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M479.849 158.024H478.613V160.701H479.849V158.024Z",
    fill: "#163240"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M479.231 142.659L477.615 148.755L475.999 154.85H477.058L475.999 158.847H479.231H479.335V143.048L479.231 142.659Z",
    fill: "#439E9B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M481.407 154.85H482.467L480.85 148.755L479.335 143.048V158.847H482.467L481.407 154.85Z",
    fill: "#163240"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M484.512 221.384C497.44 198.08 512.805 178.196 530.048 162.772C551.57 143.527 580.295 124.519 599.436 140.108C633.155 167.566 727 276.962 727 276.962H581.355L484.512 221.384Z",
    fill: "#F3C12E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M286.373 333.113H722.563C722.563 333.113 700.495 291.438 648.155 276.813C595.815 262.188 578.194 195.921 520.653 201.771C465.131 207.414 286.373 333.113 286.373 333.113Z",
    fill: "#163240"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M270.06 276.121H0C0 276.121 138.422 145.016 270.06 276.121Z",
    fill: "#439E9B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M140.814 225.013H136.356V234.672H140.814V225.013Z",
    fill: "#163240"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M138.585 169.563L132.748 191.559L126.913 213.557H130.74L126.913 227.985H138.585H138.955V170.964L138.585 169.563Z",
    fill: "#439E9B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M146.427 213.557H150.257L144.419 191.559L138.955 170.964V227.985H150.257L146.427 213.557Z",
    fill: "#163240"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M166.751 227.351H163.372V234.672H166.751V227.351Z",
    fill: "#163240"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M165.06 185.322L160.637 201.995L156.213 218.668H159.116L156.213 229.602H165.06H165.342V186.382L165.06 185.322Z",
    fill: "#439E9B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M171.006 218.668H173.906L169.483 201.995L165.342 186.382V229.602H173.906L171.006 218.668Z",
    fill: "#163240"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M584.748 175.07H582.71V179.485H584.748V175.07Z",
    fill: "#163240"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M583.73 149.713L581.062 159.774L578.394 169.832H580.143L578.394 176.431H583.73H583.901V150.352L583.73 149.713Z",
    fill: "#439E9B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M587.317 169.832H589.067L586.399 159.774L583.901 150.352V176.431H589.067L587.317 169.832Z",
    fill: "#163240"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M607.114 156.445H605.337V160.29H607.114V156.445Z",
    fill: "#163240"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M606.224 134.359L603.899 143.12L601.575 151.881H603.101L601.575 157.628H606.224H606.371V134.915L606.224 134.359Z",
    fill: "#439E9B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M609.348 151.881H610.874L608.549 143.12L606.371 134.915V157.628H610.874L609.348 151.881Z",
    fill: "#163240"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M395.628 50.5613H374.591C374.591 50.5613 384.247 30.9886 395.628 50.5613Z",
    fill: "#D8D9EB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M405.252 50.5613H384.215C384.215 50.5613 393.879 21.1863 405.252 50.5613Z",
    fill: "#D8D9EB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M414.04 50.5613H398.291C398.291 50.5613 405.524 28.568 414.04 50.5613Z",
    fill: "#D8D9EB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M442.823 21.4899H462.284C462.284 21.4899 453.342 3.38987 442.823 21.4899Z",
    fill: "#D8D9EB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M489.431 21.4899H508.891C508.891 21.4899 499.949 3.38987 489.431 21.4899Z",
    fill: "#D8D9EB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M464.526 21.4899H499.161C499.161 21.4899 483.239 -26.8585 464.526 21.4899Z",
    fill: "#D8D9EB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M450.062 21.4899H475.993C475.993 21.4899 464.079 -14.7074 450.062 21.4899Z",
    fill: "#D8D9EB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M586.252 41.691H554.872C554.872 41.691 569.289 12.5051 586.252 41.691Z",
    fill: "#D8D9EB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M604.816 41.6911H573.436C573.436 41.6911 587.855 -2.11699 604.816 41.6911Z",
    fill: "#D8D9EB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M617.92 41.6911H594.427C594.427 41.6911 605.223 8.8916 617.92 41.6911Z",
    fill: "#D8D9EB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M568.626 41.6911H537.246C537.246 41.6911 551.677 27.0981 568.626 41.6911Z",
    fill: "#D8D9EB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M538.95 140.721C538.486 140.212 537.921 139.805 537.291 139.527C536.661 139.248 535.98 139.103 535.292 139.102H534.133V137.504C534.762 137.331 535.294 136.921 535.393 136.34C536.405 136.79 538.21 136.042 537.923 134.476C539.4 134.255 541.294 132.612 539.787 131.033C540.117 131.041 540.443 130.959 540.731 130.798C541.019 130.636 541.259 130.4 541.424 130.114C541.728 129.515 541.491 128.639 540.87 128.428C541.869 127.763 542.532 126.503 542.335 125.289C542.159 124.224 541.225 123.305 540.205 123.241C540.151 123.127 540.093 123.012 540.034 122.9C540.158 122.651 540.22 122.375 540.213 122.097C540.207 121.818 540.133 121.546 539.997 121.302C539.817 121.006 539.543 120.777 539.22 120.652C538.897 120.526 538.541 120.511 538.207 120.607C538.413 119.721 537.409 118.815 536.583 119.151C536.503 118.76 536.314 118.399 536.039 118.11C535.763 117.821 535.412 117.615 535.025 117.516C534.638 117.434 534.236 117.466 533.867 117.608C533.498 117.75 533.178 117.995 532.946 118.315C532.905 117.95 532.755 117.607 532.514 117.331C532.273 117.055 531.953 116.859 531.598 116.77C531.24 116.705 530.871 116.754 530.542 116.91C530.214 117.065 529.942 117.32 529.766 117.638C529.57 117.244 529.257 116.921 528.87 116.712C528.483 116.503 528.04 116.419 527.604 116.472C527.168 116.551 526.766 116.762 526.454 117.077C526.141 117.391 525.932 117.793 525.854 118.229C525.48 117.98 525.029 117.874 524.583 117.93C524.138 117.987 523.727 118.203 523.428 118.538C523.139 118.896 522.98 119.341 522.976 119.8C522.971 120.26 523.122 120.708 523.404 121.071C522.222 120.914 521.13 122.059 521.024 123.286C520.837 125.417 522.272 126.551 524.107 126.551C524.339 126.56 524.571 126.527 524.792 126.453V134.175C524.792 136.604 526.182 137.818 528.416 137.818H528.948C529.159 137.818 529.497 137.946 529.537 138.553V139.086H529.119C528.365 139.087 527.618 139.237 526.923 139.528C526.227 139.82 525.596 140.246 525.066 140.782L518.004 135.001C517.864 134.885 517.713 134.786 517.551 134.705L516.96 134.047L509.07 125.292C508.909 125.112 508.711 124.97 508.489 124.876C508.547 124.613 508.528 124.338 508.433 124.085C508.339 123.832 508.173 123.612 507.956 123.451L506.971 122.735C506.864 122.65 506.729 122.609 506.592 122.62C506.456 122.632 506.329 122.696 506.239 122.799C506.199 122.848 506.171 122.905 506.156 122.967L505.783 122.7L504.095 121.22C503.988 121.142 503.855 121.107 503.723 121.122C503.591 121.137 503.469 121.201 503.382 121.301C503.295 121.401 503.248 121.53 503.251 121.663C503.254 121.796 503.306 121.923 503.397 122.019L504.598 123.071L504.527 123.017C504.42 122.932 504.284 122.891 504.148 122.903C504.011 122.915 503.885 122.979 503.794 123.081C503.719 123.187 503.688 123.318 503.705 123.446C503.723 123.575 503.789 123.692 503.89 123.774C503.788 123.717 503.669 123.699 503.554 123.721C503.439 123.744 503.336 123.806 503.262 123.896C503.184 124.014 503.156 124.157 503.184 124.296C503.212 124.434 503.293 124.556 503.411 124.634L503.624 124.791C503.533 124.765 503.436 124.767 503.346 124.797C503.256 124.826 503.176 124.882 503.118 124.956C503.04 125.074 503.012 125.217 503.04 125.356C503.068 125.494 503.15 125.615 503.267 125.694L505.251 127.137C505.239 127.552 505.389 127.955 505.669 128.261L514.35 137.919C514.609 138.208 514.927 138.438 515.282 138.593L523.29 144.899C523.29 144.981 523.29 145.061 523.29 145.146V169.345C523.29 169.415 523.318 169.483 523.368 169.533C523.418 169.583 523.485 169.611 523.556 169.611H525.505C525.505 169.611 528.256 189.285 526.464 197.226C526.402 197.267 526.351 197.323 526.316 197.388C526.28 197.454 526.261 197.527 526.259 197.601C526.271 197.809 526.242 198.018 526.174 198.215C526.105 198.412 525.998 198.593 525.859 198.749C524.877 199.79 523.22 201.145 521.17 201.241C520.998 201.242 520.833 201.309 520.709 201.429C520.586 201.548 520.513 201.711 520.507 201.883C520.507 202.149 520.507 202.381 520.507 202.381H538.231L538.253 202.014L538.365 199.851L538.46 197.505C538.817 193.199 538.46 187.426 538.245 183.429C537.773 175.19 538.373 169.619 538.373 169.619C538.452 169.619 538.61 166.463 538.735 163.622H539.616L539.96 169.93C539.978 170.345 540.156 170.737 540.455 171.025C540.26 171.152 540.099 171.325 539.984 171.528C539.87 171.731 539.807 171.958 539.8 172.191V173.411C539.794 173.548 539.841 173.682 539.931 173.785C540.021 173.888 540.148 173.953 540.285 173.965C540.347 173.968 540.41 173.957 540.468 173.933V174.889C540.461 174.958 540.469 175.028 540.49 175.095C540.512 175.161 540.547 175.222 540.594 175.274C540.64 175.325 540.698 175.367 540.761 175.395C540.825 175.424 540.894 175.438 540.964 175.438C541.033 175.438 541.102 175.424 541.166 175.395C541.23 175.367 541.287 175.325 541.333 175.274C541.38 175.222 541.415 175.161 541.437 175.095C541.459 175.028 541.466 174.958 541.459 174.889V174.665V175.224C541.453 175.361 541.5 175.495 541.589 175.598C541.679 175.701 541.805 175.765 541.941 175.778C541.946 175.656 541.997 175.541 542.083 175.454C542.169 175.367 542.284 175.316 542.406 175.31C542.528 175.304 542.648 175.344 542.742 175.421C542.837 175.499 542.898 175.609 542.916 175.73C542.986 175.727 543.054 175.71 543.118 175.681C543.181 175.651 543.238 175.609 543.285 175.558C543.333 175.506 543.369 175.445 543.393 175.379C543.417 175.314 543.427 175.244 543.424 175.174V174.907C543.458 174.996 543.516 175.073 543.593 175.128C543.67 175.184 543.761 175.215 543.856 175.219C543.996 175.213 544.129 175.151 544.224 175.047C544.32 174.943 544.37 174.806 544.364 174.665V172.034C544.367 171.62 544.25 171.215 544.029 170.865C544.175 170.704 544.288 170.514 544.36 170.308C544.432 170.103 544.463 169.885 544.449 169.667L544.053 162.573C544.825 162.043 545.456 161.334 545.892 160.506C546.328 159.677 546.556 158.755 546.556 157.819V149.876C546.554 147.702 545.794 145.598 544.405 143.926C543.016 142.254 541.087 141.12 538.95 140.721ZM533.137 197.175C533.06 197.214 532.995 197.272 532.949 197.344C532.902 197.416 532.875 197.499 532.871 197.585C532.883 197.793 532.854 198.002 532.786 198.199C532.717 198.396 532.61 198.577 532.472 198.733C532.238 198.981 531.992 199.218 531.734 199.441L531.779 197.471C532.133 193.167 531.779 187.405 531.561 183.413C531.089 175.174 531.689 169.603 531.689 169.603H532.163C532.163 169.603 534.913 189.215 533.137 197.175Z",
    fill: "#163240"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1533_2467",
    x1: 348.24,
    y1: 126.242,
    x2: 348.24,
    y2: 332.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#487FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6E98B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#90AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ADC0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4CFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5DAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E2E2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E9E7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE8C5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeDesktop);
export default __webpack_public_path__ + "static/media/landscape-desktop.c0d3450989b3d05964c7ca9bace8f0c3.svg";
export { ForwardRef as ReactComponent };